import React, { useEffect } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DOMPurify from 'dompurify';
import { translate } from '../Services/translation';

const ProductInformationAccordion = (props) => {
  const {
    productInformation,
    longdescription,
    technical,
    manuals,
    media,
    accessories,
    spareparts,
  } = props;

  const showGeneralInformation = productInformation || longdescription;

  const cleanHtml = (dirtyHTML) => {
    var cleaned = DOMPurify.sanitize(dirtyHTML, {
      USE_PROFILES: { html: true },
    });
    return cleaned;
  };

  const columnClass = media.length > 2 ? 'small-12' : 'small-12 large-6';

  useEffect(() => {
    const placeholder = document?.querySelector(
      '.product-information__tabs-placeholder'
    );
    if (placeholder) {
      placeholder.remove();
    }
  }, []);

  return (
    <div className="product-page__accordion-wrapper">
      {showGeneralInformation && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1"
          >
            <Box>
              <div className="product-page__accordion__accordion-header">
                <div className="icon-information"></div>
                {translate('productpage.info')}
              </div>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              {longdescription && (
                <div
                  className="filter-modal__long-description"
                  dangerouslySetInnerHTML={{
                    __html: cleanHtml(longdescription),
                  }}
                ></div>
              )}
              {productInformation &&
                productInformation.map((info, i) => (
                  <>
                    {info.Title && info.Text && (
                      <div
                        className="faq-block__item"
                        data-title={info.Title}
                        data-text={info.Text}
                      ></div>
                    )}
                  </>
                ))}
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      {technical && technical.length > 0 && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-technical"
            id="panel2"
          >
            <Box>
              <div className="product-page__accordion__accordion-header">
                <div className="icon-technical"></div>
                {translate('productpage.technical')}
              </div>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <div className="product-page__tabs__field-list">
                {technical.map((spec, i) => (
                  <dl className="small-12">
                    <dt className="small-6 caption-4">{spec.ViewName}</dt>
                    <dd className="small-6" dangerouslySetInnerHTML={{__html: cleanHtml(spec.Value)}}></dd>
                  </dl>
                ))}
              </div>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      {media && media.length > 0 && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-media"
            id="panel3"
          >
            <Box>
              <div className="product-page__accordion__accordion-header">
                <div className="icon-videos"></div>
                {translate('productpage.videos')}
              </div>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <div className="product-page__videos-container">
                <div className="product-page__videos-wrapper">
                  {media.map((video, i) => (
                    <div
                      className={
                        'product-page__videos-wrapper--videos ' +
                        columnClass +
                        ' columns'
                      }
                    >
                      <div
                        className="video__embeded"
                        dangerouslySetInnerHTML={{ __html: video }}
                      ></div>
                    </div>
                  ))}
                </div>
              </div>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      {accessories && accessories.length > 0 && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4-accessories"
            id="panel4"
          >
            <Box>
              <div className="product-page__accordion__accordion-header">
                <div className="icon-package"></div>
                {translate('productpage.accessories')}
              </div>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <ul className="row-products">
                {accessories.map((accessory, i) => (
                  <li
                    className="columns small-6 medium-4 large-3 product__container"
                    dangerouslySetInnerHTML={{
                      __html: cleanHtml(accessory.children[0]),
                    }}
                  ></li>
                ))}
              </ul>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      {spareparts && spareparts.length > 0 && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5-spareparts"
            id="panel5"
          >
            <Box>
              <div className="product-page__accordion__accordion-header">
                <div className="icon-spare-parts"></div>
                {translate('productpage.spareparts')}
              </div>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <ul className="row-products">
                {spareparts.map((sparepart, i) => (
                  <li
                    className="columns small-6 medium-4 large-3 product__container"
                    dangerouslySetInnerHTML={{
                      __html: cleanHtml(sparepart.children[0]),
                    }}
                  ></li>
                ))}
              </ul>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      {manuals && manuals.length > 0 && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel6-manuals"
            id="panel6"
          >
            <Box>
              <div className="product-page__accordion__accordion-header">
                <div className="icon-pdf"></div>
                {translate('productpage.manuals')}
              </div>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <div className="product-page__tabs__manual-container">
                {manuals &&
                  manuals.map((manual) => (
                    <div className="product-page__tabs__manual">
                      <div className="icon-pdf"></div>
                      <a href={manual.Url} target="_blank">
                        {manual.Filename}
                      </a>
                    </div>
                  ))}
              </div>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
};

export default ProductInformationAccordion;
